import * as React from 'react';
import styled from 'styled-components'
import {OuterURL} from "../../../../config/view_const/outer_url";
import {Li, LiberaInc, Title, Ul} from "./share/footer_components";
import OuterLink from "../../atom/outer_link";
import {ConstBreakPoint, ConstColor} from "../../../../config/styles_const/styles_const";
import ParagraphSup from "../../atom/text/paragraph_sup";

interface IProps {
}

const BeforeLoginFooter: React.FC<IProps> = (props) => {

    const {} = props;

    return (
        <Wrapper>
            <Area area={"service"}><Title bold={true}>サービスに関して</Title></Area>
            <Area area={"serviceInfo"}>
                <Ul>
                    <Li><OuterLink href={OuterURL.qaURL}><ParagraphSup>FAQ</ParagraphSup></OuterLink></Li>
                    <Li><OuterLink href={OuterURL.liberaForProURL}><ParagraphSup>エキスパートの方はこちら</ParagraphSup></OuterLink></Li>
                    <Li><OuterLink
                        href={OuterURL.liberaForClientURL}><ParagraphSup>法人の方はこちら</ParagraphSup></OuterLink></Li>
                    <Li><OuterLink href={OuterURL.termURL}><ParagraphSup>利用規約</ParagraphSup></OuterLink></Li>
                    <Li><OuterLink
                        href={OuterURL.privacyURL}><ParagraphSup>プライバシーポリシー</ParagraphSup></OuterLink></Li>
                </Ul>
            </Area>
            <Area area={"company"}><Title bold={true}>運営企業に関して</Title></Area>
            <Area area={"companyInfo"}>
                <Ul>
                    <Li><OuterLink href={OuterURL.companyURL}><ParagraphSup>企業概要</ParagraphSup></OuterLink></Li>
                    <Li><OuterLink href={OuterURL.employmentURL}><ParagraphSup>採用情報</ParagraphSup></OuterLink></Li>
                </Ul>
            </Area>
            {/*<Area area={"authLink"}>*/}
            {/*    <ButtonLinkWrapper>*/}
            {/*        <ButtonLink to={"/customer/_create"}>新規登録</ButtonLink>*/}
            {/*        <ButtonLink to={"/login"}>ログイン</ButtonLink>*/}
            {/*    </ButtonLinkWrapper>*/}
            {/*</Area>*/}
            <Area area={"inc"}>
                <LiberaInc>© Libera Inc.</LiberaInc>
            </Area>
        </Wrapper>
    )
};

const template = `
        "service     . company     .   authLink "
        "serviceInfo . companyInfo .   .        "
        ".           . inc         inc inc      "
    `;

const templateSP = `
    "service      "
    "serviceInfo  "
    "company      "
    "companyInfo  "
    "authLink     "
    "inc          "
    `;

const Wrapper = styled.div`
    display: grid;
    grid-template-areas: ${templateSP};
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto auto auto auto;
    grid-column-gap: 0;
    grid-row-gap: 0;
    background-color: ${ConstColor.FooterBg};
    padding: 30px;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        padding: 50px 50px 30px 50px;
        grid-template-areas: ${template};
        grid-template-columns: auto 100px auto 1fr auto;
        grid-template-rows: auto 1fr auto;
    }
`;

const Area = styled.div<{ area: string }>`
    grid-area: ${(props) => props.area};
`;

export default BeforeLoginFooter;



// WEBPACK FOOTER //
// ./src/presentation/common/organism/footer/before_login_footer.tsx